import {useSortable} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";
import "./sortable.css";

export const SortableCard = ({card, children, onClick, isOver, isEditing, disabled = false}) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({
        id: `card-${card.id}`,
        disabled: disabled || isEditing,
        data: {
            type: "card",
            card,
        },
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.25 : 1,
    };
    const dragProps = !isEditing && !disabled
        ? { ...attributes, ...listeners }
        : {};
    return (
        <>
            <div
                ref={setNodeRef}
                style={style}
                className={!isEditing ? `boardCard ${isOver ? "boardCard--over" : ""}` : null}
                onClick={onClick}
                {...dragProps}
            >
                {children}
            </div>
        </>
    );
};
